import React, { useLayoutEffect, useState } from 'react'
import { useContext } from 'react'
// import { BiRightArrowAlt, BiTrendingUp } from 'react-icons/bi'
import { BiTrendingUp } from 'react-icons/bi'
// import { BsSearch } from 'react-icons/bs'
import { FaPlus, FaMinus, FaChevronRight, FaChevronLeft, FaShoppingBag } from 'react-icons/fa'
import { FiExternalLink } from 'react-icons/fi'
import { Link, useNavigate } from 'react-router-dom'
import UserContext from '../../frontendTestContext/UserContext'
import Footer from '../../components/footer/Footer'
import LandingPage from '../../components/landing-page/LandingPage'

const Home = (props) => {
    const userContextUsed = useContext(UserContext)
    const shopData = userContextUsed.shop
    const navigate = useNavigate()
    const cartData = userContextUsed.cart

    const productListX = shopData.products;
    const productList = productListX.map((product) => {
        const hasBeenAddedToCart = cartData.items.some(
        (item) => item.itemId === product.productDetailsFromBackend.productId);

            return {
                ...product,
                productDetailsFromBrowser: {
                ...product.productDetailsFromBrowser,
                hasBeenAddedToCart: hasBeenAddedToCart,
            },
        };
    });

    const sortedProducts = productList

    const trendingProductsFiltered = sortedProducts.filter((product)=>{
        return product.productDetailsFromBackend.productIsTrending === true
    })

    function handleLoader(value, skip){
        props.handleLoader(value, skip)
    }

    const trendingProducts = trendingProductsFiltered.map((product)=>{

        const cartStatus = product.productDetailsFromBrowser.hasBeenAddedToCart
        const detailsFromBackend = product.productDetailsFromBackend
        // const detailsFromBrowser = product.productDetailsFromBrowser
        return (
            <div className="product" key={detailsFromBackend.productId}>
                <div className="top" style={{
                    backgroundImage: `linear-gradient(#0000, #000e), url(${detailsFromBackend.productUrls.productImgUrl})`,
                }}>
                    <Link onClick={()=>{
                        handleLoader(true, false)
                    }} to={`/product/${detailsFromBackend.productUrls.productUrl}`} className='product__link'>
                        <FiExternalLink />
                    </Link>
                    <div className="product-details">
                        <div className="product-name">
                            {detailsFromBackend.productName}
                        </div>
                        <div className="product-price">
                            ${detailsFromBackend.productPriceInDollar}
                        </div>
                    </div>
                </div>
                <div className={cartStatus ? "bottom in-cart" : "bottom"} onClick={()=>{
                    if (cartStatus){
                        props.removeFromCart(detailsFromBackend.productId)
                    }
                    else {
                        props.addToCart(detailsFromBackend.productId)
                    }
                }}>
                    {cartStatus ? <FaMinus />:
                    <FaPlus />}
                    <span>
                        {cartStatus ? "Remove from Cart": "Add to Cart"}
                    </span>
                </div>
            </div>
        )
    })

    const [customCarousel, setCustomCarousel] = useState({
        toShow: "show-first",
    })

    function nextHolder(){
        const showing = customCarousel.toShow
        if(showing === "show-first"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-second"
                })
            })
        } else if(showing === "show-second"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-third"
                })
            })
        } else if(showing === "show-third"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-first"
                })
            })
        }
    }

    function prevHolder(){
        const showing = customCarousel.toShow
        if(showing === "show-first"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-third"
                })
            })
        } else if(showing === "show-second"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-first"
                })
            })
        } else if(showing === "show-third"){
            setCustomCarousel((prev)=>{
                return ({
                    ...prev,
                    toShow: "show-second"
                })
            })
        }
    }

    // const [showIntro, setShowIntro] = useState(false)
    // const [showIntroX, setShowIntroX] = useState(false)

    useLayoutEffect(()=>{
    }, [])
    
    function scrolled(){
        // homeContent.addEventListener("scroll", (e)=>{
        // })

        const homeContent = document.getElementById("home-content")
        // const intro = document.getElementById("intro")
        const coolLogo = document.getElementById("cool-logo")
        const bgx = document.getElementById("bgx")
        const scrollTop = homeContent.scrollTop

        // intro.style.transform = `translateY(-${scrollTop}px)`
        // intro.style.top = `-${scrollTop-80}px`
        
        coolLogo.style.transform = `translateY(${scrollTop}px)`

        bgx.style.opacity = `${ scrollTop/100}`
    }

  return (
    <div className='home' id='home'>
        <div onScroll={scrolled} onTouchStart={scrolled} onTouchEnd={scrolled} onTouchMove={scrolled} className="content" id='home-content'>
            <div className={`intro-heading`} id='intro'>
                <div className="bg" id='bg'></div>
                <div className="bgx" id='bgx'></div>
                <img src="./intro.png" alt="shoptinga" />
                <div id='cool-logo' className="cool-logo">
                    <img src="./cool-logo.png" alt="shoptinga" />
                </div>
            </div>
            <div className="intro__carousel">
                <button className='prev-slide' onClick={prevHolder}>
                    <FaChevronLeft />
                </button>
                <button className='next-slide' onClick={nextHolder}>
                    <FaChevronRight />
                </button>
                <div className={`slide ${customCarousel.toShow}`}>
                    <div className="line-1">
                        <div className="progress"></div>
                    </div>
                    <div className="bg i">
                    </div>
                    <div className="holder i">
                        <h2>
                            <span>Discover a World of Digital Possibilities</span>
                        </h2>
                        <p>
                            Experience the future of digital commerce. Shoptinga connects you with a vast selection of digital products,  from software to media, courses and Ebooks
                        </p>
                    </div>
                    <div className="holder ii">
                        <h2>
                            {/* Discover, Buy and Sell Digital Products on Shoptinga™ */}
                            <span>Monetize Your Digital Creations</span>
                        </h2>
                        <p>
                            Turn your digital creations into profits. Shoptinga provides a platform for creators like you to showcase and sell your digital products.
                        </p>
                    </div>
                    <div className="holder iii">
                        <h2>
                            {/* Discover, Buy and Sell Digital Products on Shoptinga™ */}
                            <span>Seamless Trading with Crypto and Fiat</span>
                        </h2>
                        <p>
                            Securely buy and sell digital products with ease. Shoptinga offers seamless transactions, supporting cryptocurrencies and fiat payments for reliable and efficient trading.
                        </p>
                    </div>
                </div>
                <button className='signup__link' onClick={()=>{
                    handleLoader(true, true)
                    navigate("/shop")
                }}>
                    <span>Start Shopping</span>
                    <FaShoppingBag style={{marginLeft: "10px"}}/>
                </button>
            </div>

            {trendingProductsFiltered.length > 0 ? <div className="trending-products">
                <div className='heading'>
                    <div className="title">
                        <p>Trending Products</p>
                        <Link onClick={()=>{
                            handleLoader(true, true)
                        }} to={"/shop"}>
                            <BiTrendingUp />
                        </Link>
                    </div>
                    <div className="sub-title">
                        Enjoy the latest Products from our Top Creators
                    </div>
                </div>
                <div className="container">
                    {trendingProducts}
                </div>
            </div> : <div className='spacer' style={{marginBottom: "70px"}}></div>}
            <LandingPage handleLoader={props.handleLoader} />
        <Footer />
        </div>
    </div>
  )
}

export default Home